const fetchJsonParams = {
  Accept: "application/json",
  "Content-Type": "application/json"
};
const formHeaderParams = {
  Accept: "application/json",
  "Content-Type": "application/x-www-form-urlencoded"
};
const FileSaveHeadersPDF = {
  "Content-Type": "application/pdf",
  Accept: "application/pdf"
};
export {
  FileSaveHeadersPDF,
  fetchJsonParams,
  formHeaderParams
};
